// extracted by mini-css-extract-plugin
export default {"Segment":"📚19-10-2nE6h6","shape_pill":"📚19-10-2xOf5O","shape_rounded":"📚19-10-2JaraF","shape_squared":"📚19-10-2wGub5","selected":"📚19-10-2JxSKs"};